<template>
  <div class="banner">
    <banner-container></banner-container>
  </div>
</template>
<script>
import BannerContainer from '@/components/banner/Container.vue'
export default {
  name: 'banner',
  components: {
    BannerContainer
  }
}
</script>
<style lang="stylus">
.banner
  width 100%
  height 100%
  background #F7F9FB
</style>
